import cx from 'classnames';

import styles from './slider.module.scss';
import { CalcPointProps, calcPoint } from './util';

interface Props extends CalcPointProps {
  isActive: boolean;
}

const Step = ({ min, max, point, isActive }: Props) => {
  return (
    <div
      className={cx(styles.step, { [styles.isActive]: isActive })}
      style={{ left: calcPoint({ min, max, point }) }}
    />
  );
};

export default Step;
